import React, { useState, useRef, useEffect } from "react";
import Modal from "react-modal"
import Select from "react-select"

import { SingleOption, 
  customStylesMobileModal,
  parseDate, 
  getLocaleStringRoundedInt } from "../../utils/utils.js";

import CaretDown from "../../../assets/img/caret-down-blue.svg";
import fileIcon from "../../../assets/img/file.svg";
import crossIcon from "../../../assets/img/cross-icon.svg";
import { hideGreyBackground, showGreyBackground } from "../../utils/windows.js";
import { allMateriales } from "../../utils/materiales.js";

import { customModalStyles } from "../../utils/styles"

import closeIcon from "../../../assets/img/cross-icon.svg"
import chevronRight from "../../../assets/img/chevron-right.svg"

const regularizacionModalScrollMode = "cliente";

const styles = customModalStyles(20)
styles.content.padding = 0
styles.content.width = "343px"
styles.content.maxWidth = "calc(100vw - 32px)"
styles.content.boxSizing = "border-box"

const regularizacionModalSelectStyles = {
  ...customStylesMobileModal,
  control: (base, state) => ({
    ...customStylesMobileModal.control(base, state),
    borderBottomLeftRadius: state.menuIsOpen ? 0 : base.borderBottomLeftRadius,
    borderBottomRightRadius: state.menuIsOpen ? 0 : base.borderBottomRightRadius,
  }),
  menu: (base, state) => ({
    ...customStylesMobileModal.menu(base, state),
    backgroundColor: "#ffffff",
    width: "100%",
    minWidth: "100%",
    marginTop: "-1px",
    borderTop: "1px solid #7c97ab",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    boxSizing: "border-box",
    zIndex: 20,
  }),
  menuList: (base, state) => ({
    ...customStylesMobileModal.menuList(base, state),
    backgroundColor: "#ffffff",
  }),
}

if (regularizacionModalScrollMode === "codex") {
  styles.content.position = "fixed"
  styles.content.top = "16px"
  styles.content.maxHeight = "calc(100vh - 32px)"
  styles.content.display = "flex"
  styles.content.flexDirection = "column"
  styles.content.overflow = "hidden"
} else {
  styles.content.position = "relative"
  styles.content.top = "auto"
  styles.content.left = "auto"
  styles.content.right = "auto"
  styles.content.bottom = "auto"
  styles.content.transform = "none"
  styles.content.margin = "16px auto"
  styles.content.overflow = "visible"
}

const SolicitudRegularizacionMobile = ({
  goBack, 
  selectedTransaccion, 
  parseHora,
  parseIdentificador,
  getConfDocsLitros, 
  getValueConfirmado, 
  getConfDocsPesos, 
  litrosConfirmados, 
  setLitrosConfirmados, 
  allLitrosConfirmados,
  tanque,
  setTanque,
  allTanquesForSelect,
  changeObservaciones, 
  isEditando,
  observaciones,
  uploadedFile,
  setUploadedFile,
  hiddenFileInput,
  changeUploadedFile,
  handleUploadFile,
  checkData,
  regularizar
}) => {

  const modalTitle = "Solicitud de regularización";
  const actionLabel = "Regularizar Venta";
  const emptyValue = "-";
  const formatText = (value) => value || value === 0 ? value : emptyValue;

  const transactionDetailRows = [
    {
      label: "Origen Venta",
      value: formatText(selectedTransaccion.ORIGEN_VENTA)
    },
    {
      label: "Forma Comercialización",
      value: formatText(selectedTransaccion.FORMA_COMERCIALIZACION)
    },
    {
      label: "Forma de Pago",
      value: formatText(selectedTransaccion.FORMA_PAGO)
    },
    {
      label: "Documento de Venta",
      value: formatText(selectedTransaccion.DOCUMENTO_VENTA)
    },
    {
      label: "Identificador",
      value: formatText(parseIdentificador(selectedTransaccion.ID_TRANSACCION))
    },
    {
      label: "Hora Transacción",
      value: formatText(parseHora(selectedTransaccion.HORA))
    },
    {
      label: "Material",
      value: formatText(selectedTransaccion.MATERIAL)
    },
    {
      label: "Precio por Litro",
      value: selectedTransaccion.PRECIO || selectedTransaccion.PRECIO === 0
        ? `$ ${getLocaleStringRoundedInt(selectedTransaccion.PRECIO)}`
        : emptyValue,
      alignRight: true
    }
  ];

  const adjustmentDetailRows = [
    {
      label: "Litros Controlador",
      value: getLocaleStringRoundedInt(selectedTransaccion.LITROS.controlador),
      alignRight: true
    },
    {
      label: "Litros Documentados",
      value: getLocaleStringRoundedInt(selectedTransaccion.LITROS.documentados),
      alignRight: true
    },
    {
      label: "(Lts) Documentado - Controlador",
      value: getLocaleStringRoundedInt(selectedTransaccion.LITROS.documentados - selectedTransaccion.LITROS.controlador),
      alignRight: true
    },
    {
      label: "(Lts) Confirmado - Documentado",
      value: getConfDocsLitros(),
      alignRight: true,
      isGreen: getConfDocsLitros() === 0
    },
    {
      label: "($) Controlador",
      value: getLocaleStringRoundedInt(selectedTransaccion.PESOS.controlador),
      alignRight: true
    },
    {
      label: "($) Documentado",
      value: getLocaleStringRoundedInt(selectedTransaccion.PESOS.documentados),
      alignRight: true
    },
    {
      label: "($) Confirmado",
      value: getLocaleStringRoundedInt(getValueConfirmado()),
      alignRight: true
    },
    {
      label: "($) Documentado - Controlador",
      value: getLocaleStringRoundedInt(selectedTransaccion.PESOS.documentados - selectedTransaccion.PESOS.controlador),
      alignRight: true
    },
    {
      label: "($) Confirmado - Documentado",
      value: getConfDocsPesos(),
      alignRight: true,
      isGreen: getConfDocsLitros() === 0
    }
  ];

  const closeModal = () => {
    goBack()
  }

  const openUploadedFile = () => {
    if (!uploadedFile) return;

    const fileUrl = uploadedFile.url || uploadedFile.URL || uploadedFile.href;
    if (fileUrl) {
      window.open(fileUrl, "_blank");
      return;
    }

    if (uploadedFile instanceof Blob) {
      const objectUrl = URL.createObjectURL(uploadedFile);
      window.open(objectUrl, "_blank");
      setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    }
  }

  return (
    <div className="hide-desktop mobile-big-modal min-height-1200">
      <Modal
        isOpen={true}
        onRequestClose={closeModal}
        style={styles}
        className={`responsive-modal regularizacion-solicitud-modal regularizacion-solicitud-modal--${regularizacionModalScrollMode}`}
        overlayClassName={`ReactModal__Overlay regularizacion-solicitud-modal-overlay regularizacion-solicitud-modal-overlay--${regularizacionModalScrollMode}`}
      >
        <div className="mobile-filters__title responsive-filters">
          <h1 className="responsive-modal-title">{modalTitle}</h1>
          <button className="mobile-filters__close-btn" onClick={closeModal}>
            <img src={closeIcon} alt="close modal" />
          </button>
          <p className="responsive-modal-subtitle-cc">{formatText(selectedTransaccion.MATERIAL)}</p>
        </div>
        <div className="mobile-filters__main-section">
          <div className="regularizacion-modal-sale-detail">
            {transactionDetailRows.map((row) => (
              <div className="regularizacion-modal-sale-detail__field" key={row.label}>
                <div className="mobile-modal-select-title">{row.label}</div>
                <div className={`mobile-disabled-input ${row.alignRight ? "align-right" : ""}`}>
                  {row.value}
                </div>
              </div>
            ))}
          </div>

          <table className="responsive-table separated-th-table regularizacion-modal-detail-table">
            <thead>
              <tr>
                <th>
                  <div className="th-data">Detalle</div>
                </th>
                <th>
                  <div className="th-data">Valor</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {adjustmentDetailRows.map((row) => (
                <tr key={row.label}>
                  <td>{row.label}</td>
                  <td className={row.alignRight ? "align-right" : undefined}>
                    <div className={`td-data ${row.isGreen ? "green" : ""}`}>{row.value}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="mobile-modal-select-title">Litros Confirmado</div>

          { selectedTransaccion?.TIPO_VENTA === "productos"? <div className="td-data">{getLocaleStringRoundedInt(litrosConfirmados?.value)}</div>:
            <Select
              className="eds-select cd-mb-select-last regularizacion-table-select"
              value={litrosConfirmados}
              onChange={(e) => setLitrosConfirmados(e)}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              options={allLitrosConfirmados}
              components={{ SingleOption, IndicatorSeparator: () => null }}
              styles={regularizacionModalSelectStyles}
              isClearable={false}
              autosize={false}
              isSearchable={false}
              placeholder="Seleccionar"
            />
          }

          <div className="mobile-modal-select-title">Tanque</div>
          <Select
            className="eds-select cd-mb-select-last regularizacion-table-select"
            value={tanque}
            onChange={(e) => setTanque(e)}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            options={allTanquesForSelect}
            components={{ SingleOption, IndicatorSeparator: () => null }}
            styles={regularizacionModalSelectStyles}
            isClearable={false}
            autosize={false}
            isSearchable={false}
            placeholder="Seleccionar"
          />

          <div className="mobile-modal-select-title">Observaciones</div>
          <textarea value={observaciones} onChange={(e) => changeObservaciones(e)} maxLength="280" />
          <p className="counter">{observaciones.length} /280</p>

          {!uploadedFile && !isEditando &&
            <button className="main-button grey-background with-image mobile-button" onClick={handleUploadFile}>
              <img src={fileIcon} />
              <span>Adjuntar evidencia</span>
            </button>
          }

          {uploadedFile &&
            <div className="regularizacion-files-section">
              <div className="regularizacion-files-title">
                <span>Archivos adjuntos</span>
              </div>
              <div className="uploaded-file-container">
                <div className="right-side">
                  <button className="file-name" type="button" onClick={openUploadedFile}>
                    Ver Archivo Adjunto
                  </button>
                </div>
                <button
                  className="solicitud-regularizacion-cross-icon"
                  type="button"
                  aria-label="Quitar archivo adjunto"
                  onClick={() => setUploadedFile()}
                />
              </div>
            </div>
          }
          
          <input
            className="hidden-file-input"
            type="file"
            ref={hiddenFileInput}
            accept="application/pdf"
            onChange={(e) => {
              changeUploadedFile(e.target.files[0])
            }}
            onClick={(event)=> { 
              event.target.value = null
            }}
          />

        </div>
        <div className="mobile-filters__footer">
          <button className="main-button" disabled={!checkData()} onClick={regularizar}>
            {actionLabel}
          </button>
          <button className="main-button main-button-red" onClick={closeModal}>
            Cancelar
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default SolicitudRegularizacionMobile
